// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3554":"757379cd2677262a","4861":"7aaba9352c60175f"}[chunkId] + ".css";
};